// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedAnalyzeCustomMaps1_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6863 20.8162L11.6256 23.9982L14.8076 22.9375L21.8787 15.8664L19.7573 13.7451L12.6863 20.8162ZM20.4644 13.038L21.8787 11.6238L24 13.7451L22.5858 15.1593L20.4644 13.038Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C16.515 2 20.3312 4.99225 21.5736 9.10187L21.8786 8.79688L21.8845 8.80277L23.1448 7.54245C21.3753 3.12223 17.0523 0 12 0C5.37258 0 0 5.37258 0 12C0 17.8046 4.12133 22.6466 9.59743 23.7594L10.2356 21.8448C5.55427 21.0115 2 16.9208 2 12C2 6.47715 6.47715 2 12 2ZM13.2172 23.4672L13.2186 23.4686L11.6404 23.9947L11.6351 23.9946L13.2172 23.4672Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedAnalyzeCustomMaps1 is a generated icon component.
 */
let IconMedAnalyzeCustomMaps1 = IconMedAnalyzeCustomMaps1_1 = class IconMedAnalyzeCustomMaps1 extends IconBaseElement {
    render() {
        return html `${IconMedAnalyzeCustomMaps1_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedAnalyzeCustomMaps1.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedAnalyzeCustomMaps1 = IconMedAnalyzeCustomMaps1_1 = __decorate([
    customElement('zui-icon-med-analyze-custom-maps-1')
], IconMedAnalyzeCustomMaps1);
export { IconMedAnalyzeCustomMaps1 };
